export const API_GET_ASSOCIATIONS = "API_GET_ASSOCIATIONS"
export const API_GET_ASSOCIATION_DETAIL = "API_GET_ASSOCIATION_DETAIL"
